import React from 'react';
import HeaderComponent from './HeaderComponent';
import FooterComponent from './FooterComponent';
import ShopPageSlidersListContentComponent from './ShopPageSlidersListContentComponent';

class ShopPageSlidersListComponent extends React.Component {
    render() {
        return(
            <div className="main-panel">
                <ShopPageSlidersListContentComponent location={this.props.location}/>
                <FooterComponent/>
            </div>
        );
    }
}

export default ShopPageSlidersListComponent;